<div class="estimate-collaboration-container">
    <div class="row pb-3">
        <label>{{ 'MENU_FILE_PROPERTIES_ESTIMATE_COLLABORATION_TITLE' | translate }}</label>
    </div>
    <div class="estimate-collaboration-content" [formGroup]="collaborationForm">
        <div class="row row-height">
            <div class="col-sm-4 slide-toggle"
                matTooltip="{{ 'ESTIMATE_COLLABORATION_TOGGLE_ENABLE_DISABLE' | translate }}">
                <mat-slide-toggle color="primary" (change)="collaborationEnabledToggled()"
                    formControlName="collaborationEnabled">
                    {{ isCollaborationEnabled() ? ('COLLABORATION_ON' | translate) : ('COLLABORATION_OFF' | translate) }}
                </mat-slide-toggle>
            </div>
        </div>
        <fieldset class="pb-3">
            <legend>{{ 'MENU_FILE_PROPERTIES_ESTIMATE_COLLABORATION_COLLABORATORS' | translate }}</legend>
            <div class="collaborators-table-scroll mb-3">
                <table mat-table table-border [dataSource]="dataSource">

                    <!-- Role Column -->
                    <ng-container matColumnDef="role">
                        <th mat-header-cell *matHeaderCellDef> {{ 'MENU_FILE_PROPERTIES_ESTIMATE_COLLABORATION_ROLE' |
                            translate }} </th>
                        <td mat-cell *matCellDef="let element"> {{element.role}} </td>
                    </ng-container>

                    <!-- Collaborator Column -->
                    <ng-container matColumnDef="collaborator">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'MENU_FILE_PROPERTIES_ESTIMATE_COLLABORATION_COLLABORATOR' | translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                    </ng-container>

                    <!-- Email Column -->
                    <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef> {{'MENU_FILE_PROPERTIES_ESTIMATE_COLLABORATION_EMAIL' |
                            translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                    </ng-container>

                    <!-- Access Column -->
                    <ng-container matColumnDef="access">
                        <th mat-header-cell *matHeaderCellDef> {{'MENU_FILE_PROPERTIES_ESTIMATE_COLLABORATION_ACCESS' |
                            translate}} </th>
                        <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
                            <mat-slide-toggle color="primary" (toggleChange)="toggleBtnClicked(element)"
                                [checked]="element.canEdit"
                                [disabled]="collaborationForm.controls.collaboratorAccess.disabled">
                                {{ (element.canEdit ? 'EDIT' : 'VIEW') | translate }}
                            </mat-slide-toggle>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="row-height"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClick(row)"
                        [class.selected]="selection.isSelected(row)"
                        [class.readonly-row]="collaborationForm.controls.collaboratorRowSelection.disabled"
                        class="row-height" [hidden]="row.roleId === 0"></tr>
                </table>
            </div>
            <div class="d-flex justify-content-between w-50">
                <button mat-raised-button color="primary" (click)="addCollaborator()"
                    [disabled]="collaborationForm.controls.addCollaborator.disabled">
                    {{'ADD_COLLABORATOR'| translate}}
                </button>
                <button mat-raised-button color="warn" (click)="removeAllCollaborator()"
                    [disabled]="collaborationForm.controls.removeAllCollaborators.disabled">{{'MENU_FILE_PROPERTIES_ESTIMATE_COLLABORATION_REMOVE_ALL'|
                    translate}}</button>
                <button mat-raised-button color="warn" (click)="removeSelectedCollaborator()"
                    [disabled]="collaborationForm.controls.removeSelectedCollaborator.disabled">{{'MENU_FILE_PROPERTIES_ESTIMATE_COLLABORATION_REMOVE'|
                    translate}}</button>
            </div>
        </fieldset>
        <div class="row row-height ps-3">
            <div class="col-sm-2 align-content-center">
                <label>{{'MENU_FILE_PROPERTIES_ESTIMATE_COLLABORATION_PRIMARY_USER' | translate}}</label>
            </div>
            <div class="col-sm-4 primary-user-select">
                <mat-form-field class="full-width col-sm-12" appearance="outline">
                    <mat-select formControlName="primaryUser" (selectionChange)="onPrimaryUserChange()">
                        <mat-option *ngFor="let user of collaboratorList; trackBy: trackByEmail" [value]="user.email">
                            {{getUserDisplayName(user.name)}} ({{user.role}})
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <fieldset>
            <legend>{{'MENU_FILE_PROPERTIES_ESTIMATE_COLLABORATION_COST_REVIEW' | translate}}</legend>
            <div class="row row-height align-content-center">
                <div class="col-sm-2"><label>{{'MENU_FILE_PROPERTIES_ESTIMATE_COLLABORATION_THRESHOLD' |
                        translate}}</label></div>
                <div class="col-sm-4">
                    {{costReviewThreshold}}
                </div>
            </div>
            <div class="row row-height align-content-center">
                <div class="col-sm-2"><label>{{'MENU_FILE_PROPERTIES_ESTIMATE_COLLABORATION_OPTIONAL_WORKFLOWS' |
                        translate}}</label></div>
                <div class="col-sm-4">
                    {{costReviewOptionalWorkflow}}
                </div>
            </div>
        </fieldset>
    </div>
</div>